import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, ImageOff } from 'lucide-react';
import { useAlbum } from '../lib/queries';
import PhotoLightbox from '../components/PhotoLightbox';

export default function Album() {
  const { albumId } = useParams<{ albumId: string }>();
  const { data, isLoading } = useAlbum(albumId);
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  if (isLoading) return <p className="text-ink-muted">Laddar…</p>;
  if (!data) return <p className="text-ink-muted">Album hittades inte.</p>;

  const { album, photos } = data;

  return (
    <div className="max-w-5xl mx-auto">
      <Link to="/foto" className="inline-flex items-center gap-2 text-ink-muted mb-4 hover:text-ink">
        <ArrowLeft size={16} /> Tillbaka till album
      </Link>

      <h1 className="text-3xl md:text-4xl font-serif text-primary mb-2">{album.name}</h1>
      {album.description && <p className="text-ink-muted mb-6">{album.description}</p>}

      {photos.length === 0 ? (
        <div className="bg-white rounded-2xl p-12 shadow-sm text-center">
          <ImageOff className="mx-auto mb-3 text-ink-disabled" size={48} />
          <p className="text-ink-muted">Inga foton i albumet än.</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
          {photos.map((photo, idx) => (
            <button
              key={photo.id}
              type="button"
              onClick={() => { setLightboxIndex(idx); }}
              className="block w-full"
            >
              <img
                src={photo.thumbnailUrl ?? '/placeholder.svg'}
                alt={photo.description ?? ''}
                className="aspect-square object-cover rounded w-full"
              />
            </button>
          ))}
        </div>
      )}

      {lightboxIndex !== null && (
        <PhotoLightbox
          albumId={album.id}
          photos={photos}
          currentIndex={lightboxIndex}
          currentCoverPhotoId={album.coverPhotoId}
          onClose={() => { setLightboxIndex(null); }}
          onNavigate={setLightboxIndex}
        />
      )}
    </div>
  );
}
